import classNames from 'classnames';
import CloseButton from '@/shared/components/configurator/CloseButton';
import ConstructorButton from '@/shared/components/configurator/ConstructorButton';
import {
    useConfiguratorOpenedCameraPositionValue,
    useSetCameraPosition,
} from '@/shared/components/configurator/atoms/camera-position';
import { useSetConfiguratorStepState } from '@/shared/components/configurator/atoms/configurator-step-state';
import { useConfiguratorZoomedSetState } from '@/shared/components/configurator/atoms/configurator-zoomed';
import {
    useCurrentModelStateValue,
    useSetCurrentModelState,
} from '@/shared/components/configurator/atoms/current-model-state';
import { useCurrentModelTypeValue } from '@/shared/components/configurator/atoms/current-model-type';
import { useCurrentPickerStateValue } from '@/shared/components/configurator/atoms/current-picker-state';
import { additionalDict } from '@/shared/components/configurator/dicts/additional-dict';

const ConfiguratorPicker = () => {
    const setStep = useSetConfiguratorStepState();
    const picker = useCurrentPickerStateValue();
    const currentModelState = useCurrentModelStateValue();
    const setCurrentModelState = useSetCurrentModelState();
    const setCameraPosition = useSetCameraPosition();
    const configuratorOpenedCameraPosition = useConfiguratorOpenedCameraPositionValue();
    const setConfiguratorZoomed = useConfiguratorZoomedSetState();
    const currentModelType = useCurrentModelTypeValue();

    return (
        <div className="configurator">
            <div className="configurator-top">
                <div className="configurator-title text-l">{picker.title}</div>
                <CloseButton
                    onClick={() => {
                        setStep('hero');
                        setCameraPosition(configuratorOpenedCameraPosition);
                        setConfiguratorZoomed(false);
                    }}
                />
            </div>
            <div className="configurator-body">
                <ul className="picker-list list-unstyled">
                    {picker.property.map((item, i) => {
                        const currentModelPicker = currentModelState[picker.slug];
                        return (
                            <li key={i}>
                                <button
                                    className={classNames('picker-item', {
                                        //@ts-ignore появляется из-за мультипикера, которого тут нет
                                        'picker-item--active': currentModelPicker?.value === item.slug,
                                    })}
                                    onClick={() => {
                                        setCurrentModelState((prev) => {
                                            return {
                                                ...prev,
                                                [picker.slug]: {
                                                    title: item.label,
                                                    value: item.slug,
                                                },
                                            };
                                        });
                                    }}
                                >
                                    <div className="picker-item__title text-m">{item.label}</div>
                                    {item.hint && <div className="text-s picker-hint">{item.hint}</div>}
                                </button>
                            </li>
                        );
                    })}
                </ul>

                {(picker.slug == 'reception' || picker.slug === 'exhibit' || picker.slug === 'exhibitSecond') &&
                    currentModelType === 'premium' &&
                    additionalDict[picker.slug].length > 0 && (
                        <div className="configurator-additional">
                            <div className="text-m">Дополнительные варианты</div>
                            <div className="configurator-additional-hint text-xxs">
                                Перечисленные варианты являются примерными. Предустановки, указанные в этом
                                конфигураторе, могут быть объединены. Элементы стенда могут меняться и могут быть
                                изменены по запросу клиента.
                            </div>

                            <ul className="list-styled">
                                {additionalDict[picker.slug].map((item, i) => {
                                    return (
                                        <li className="text-xxs" key={i}>
                                            {item}
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    )}
            </div>

            <div className="configurator-hero-buttons configurator-color-picker-buttons">
                <ConstructorButton
                    variant="blue"
                    onClick={() => {
                        setStep('hero');
                        setCameraPosition(configuratorOpenedCameraPosition);
                        setConfiguratorZoomed(false);
                    }}
                >
                    Сохранить и закрыть
                </ConstructorButton>
            </div>
        </div>
    );
};

export default ConfiguratorPicker;
